import { render } from "./FeedbackPopup.vue?vue&type=template&id=fcf1bb58&scoped=true"
import script from "./FeedbackPopup.vue?vue&type=script&lang=js"
export * from "./FeedbackPopup.vue?vue&type=script&lang=js"

import "./FeedbackPopup.vue?vue&type=style&index=0&id=fcf1bb58&scoped=true&lang=css"

import exportComponent from "/var/www/testback/Frontend/sdd/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fcf1bb58"]])

export default __exports__